<template>
  <page-edicion title="Editar plantilla">
    <formulario :plantilla-contenido="plantillaContenido" :paises-id="paisesId" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import api from "@/services/plantillasContenido.js";

export default {
  components: { Formulario },
  data() {
    return {
      plantillaContenido: api.crear(),
      paisesId: [],
    };
  },
  mounted() {},
  methods: {
    insertar(paisesSeleccionados) {
      var plantilla = {
        plantillaContenido: this.plantillaContenido,
        paises: paisesSeleccionados,
      };
      api.insertar(plantilla).then(() => {
        this.$router.push({ path: "/plantillasContenido" });
      });
    },
  },
};
</script>
